import { useService } from '@aesop-fables/containr-react';
import { useMutation } from '@aesop-fables/scrinium';
import { useLocation, useNavigate } from 'react-router';
import { ButtonFooter, Column, Spacer } from '../../components';
import { UpdateSignUpState } from '../../data/signUp/mutations';
import { useLoading } from '../../hooks/useLoading';
import { OffboardingWizard, offboardingWizardKey } from '../../services/offboarding';
import { MemberSignUpCard } from '../dash/MemberSignUpCard';
import { Grid, Typography } from '@mui/material';

const OffboardingCompleteView = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setLoading } = useLoading();

  const offboardingWizard = useService<OffboardingWizard>(offboardingWizardKey);
  const updateSignUpState = useMutation(new UpdateSignUpState());

  const current = location.pathname;

  const onDone = async () => {
    setLoading(true);
    const next = offboardingWizard.nextStep(location);

    await updateSignUpState.action({
      lastCompletedStep: current,
      offboardingComplete: true,
    });

    navigate(next.route);
    setLoading(false);
  };

  return (
    <Column
      style={{
        padding: '70px 100px 150px 100px',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}>
      <Grid gap='20px' container direction='column' style={{ flexGrow: 1 }}>
        <Typography variant='p45'>You’re all set!</Typography>
        <Typography variant='p20' color='secondary.dark'>
          You can always find this link to your custom sign-up page on your dashboard.
        </Typography>
        <Spacer height='xxs' />
        <MemberSignUpCard />
      </Grid>
      <ButtonFooter
        primaryButton={{
          label: 'Go to dashboard',
          onClick: onDone,
        }}
        secondaryButton={{
          label: '',
        }}
      />
    </Column>
  );
};

export default OffboardingCompleteView;
